/**
 * ============================================================================
 * CUSTOMIZATION SCRIPT FOR TEEINBLUE
 * Store: Theme Customization
 * Features:
 * - Cleaned up: Removed all unrelated functions
 * - Accurate "Magic Studio" AI Loading Popup with Progress Dot & Lora font
 * - "View Photo Guide" button injection with Info Icon (i)
 * - Photo Upload Box styling & Extra Instructions
 * - 0ms instant upload detection & Debounced MutationObserver (rAF)
 * ============================================================================
 */
(function () {
    'use strict';

    if (window._tiCustomScriptLoaded) return;
    window._tiCustomScriptLoaded = true;

    window.TIB_DEBUG = false;
    window.TIB_ENABLE_PHOTO_GUIDE = typeof window.TIB_ENABLE_PHOTO_GUIDE !== 'undefined' ? window.TIB_ENABLE_PHOTO_GUIDE : false;
    window.TIB_GUIDELINE_IMAGE_URL = window.TIB_GUIDELINE_IMAGE_URL || "";
    window.TIB_GUIDELINE_HTML = window.TIB_GUIDELINE_HTML || "";

    function tibLog(...args) {
        if (window.TIB_DEBUG) {
            console.log('[TIB Debug]', ...args);
        }
    }

    const t = {
        sub_title: "Magic Studio",
        main_title: "Hang Tight, Magic in Progress",
        status_text: "Your artwork is being created",
        subtext: "Ready in 10–15 seconds",
        footer_text: "Keep this screen open",
        guide_btn_text: "View Photo Guide",
        guide_modal_title: "PHOTO UPLOAD GUIDELINES",
        select_photo_btn: "Select Photo",
        placeholder_text: "No photo selected yet"
    };

    // 2. EMBEDDED UNIFIED CSS INJECTION
    function injectUnifiedStyles() {
        if (document.getElementById('tib-custom-styles')) return;

        const style = document.createElement('style');
        style.id = 'tib-custom-styles';
        style.textContent = `
            @import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,500;0,600;1,500&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

            /* --- 1. PHOTO FIELD CONTAINER & HEADER --- */
            .tee-field--photo {
                font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            }

            .tee-field--photo .tee-field__header {
                display: flex !important;
                align-items: center !important;
                justify-content: space-between !important;
                margin-bottom: 8px !important;
                width: 100% !important;
            }

            .tee-field--photo .tee-field__heading,
            .tee-field--photo .tee-field__title {
                display: flex !important;
                align-items: center !important;
                justify-content: flex-start !important;
                width: 100% !important;
                font-size: 14px !important;
                font-weight: 600 !important;
                color: #312b36 !important;
                margin: 0 !important;
            }

            /* View Photo Guide Button */
            .tib-view-photo-guide {
                display: inline-flex;
                align-items: center;
                gap: 6px;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                color: #312B36;
                text-decoration: underline;
                text-underline-offset: 3px;
                transition: opacity 0.2s ease;
                user-select: none;
                margin-left: auto;
            }

            .tib-view-photo-guide:hover {
                opacity: 0.75 !important;
            }

            .tib-view-photo-guide svg {
                width: 16px;
                height: 16px;
                fill: #312B36;
                flex-shrink: 0;
            }

            /* --- 2. UPLOAD BOX (INITIAL / UNLOADED STATE) --- */
            .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)),
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)) {
                background: #e9e9e9ff;
                border: 1px dashed #D6D0C5;
                border-radius: 10px;
                padding: 12px 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-height: 56px;
                box-sizing: border-box;
                transition: border-color 0.2s ease, background-color 0.2s ease;
                flex-wrap: wrap;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)):hover {
                border-color: #B5AEA2 !important;
            }

            /* Placeholder Text */
            .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)) .tee-photo-head,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)) .tee-photo-head {
                display: flex !important;
                align-items: center !important;
                flex: 1 !important;
            }
 
            .tee-field--photo .tee-photo-message {
                order: 4;
                flex: 0 0 100%;
            }

            /* Hide label ONLY when it is an empty placeholder AND there is NO history */
            .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-preview-history)) .tee-photo-label,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-preview-history)) .tee-photo-label {
                display: none !important;
            }

            /* Only show text placeholder when there is NO history and NO uploaded image */
            .tee-field--photo .tee-photo:not(:has(.tee-photo-preview-history)):not(:has(.tee-photo-image)):not(:has(.tee-photo-uploading)) .tee-photo-head::before,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:not(:has(.tee-photo-preview-history)):not(:has(.tee-photo-image)):not(:has(.tee-photo-uploading)) .tee-photo-head::before {
                content: "${t.placeholder_text}" !important;
                font-size: 14px !important;
                color: #767069 !important;
                font-weight: 400 !important;
                display: block !important;
            }

            /* When history exists: hide text placeholder and show placeholder slot [+] next to history thumbnails */
            .tee-field--photo .tee-photo:has(.tee-photo-preview-history) .tee-photo-head::before,
            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-head::before,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-preview-history) .tee-photo-head::before,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-head::before {
                content: none !important;
                display: none !important;
            }

            /* Style the placeholder slot [+] when history exists but no image selected */
            .tee-field--photo .tee-photo:has(.tee-photo-preview-history):not(:has(.tee-photo-image)) .tee-photo-label {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                width: 42px !important;
                height: 42px !important;
                min-height: 42px !important;
                border: 1.5px dashed #B5AEA2 !important;
                border-radius: 6px !important;
                background: #FFFFFF !important;
                cursor: pointer !important;
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box !important;
                flex: 0 0 42px !important;
                order: 0 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-preview-history):not(:has(.tee-photo-image)) .tee-photo-placeholder {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                width: 100% !important;
                height: 100% !important;
                border: none !important;
                background: transparent !important;
                padding: 0 !important;
                margin: 0 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-preview-history):not(:has(.tee-photo-image)) .tee-photo-placeholder svg,
            .tee-field--photo .tee-photo:has(.tee-photo-preview-history):not(:has(.tee-photo-image)) .tee-photo-placeholder .tee-icon-plus {
                width: 18px !important;
                height: 18px !important;
                fill: #767069 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-preview-history) .tee-photo-head {
                display: flex !important;
                align-items: center !important;
                gap: 10px !important;
                flex: 1 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-preview-history) .tee-photo-preview-history {
                order: 1 !important;
            }

            /* Select Photo Button */
            .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)) .tee-btn--upload,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)) .tee-btn--upload {
                background: #312b36 !important;
                color: #FAF8F5 !important;
                border: none !important;
                border-radius: 8px !important;
                padding: 8px 16px !important;
                font-size: 13.5px !important;
                font-weight: 600 !important;
                display: inline-flex !important;
                align-items: center !important;
                gap: 8px !important;
                cursor: pointer !important;
                box-shadow: none !important;
                transition: background-color 0.2s ease !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-placeholder):not(:has(.tee-photo-uploading)) .tee-btn--upload:hover {
                background: #1B1720 !important;
            }

            /* --- 3. UPLOADING STATE (MACORNER STYLE WITH BUTTON SPINNER) --- */
            .tee-field--photo .tee-photo:has(.tee-photo-uploading),
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-uploading) {
                background: #FCECEC !important;
                border: 1.5px dashed #D6D0C5 !important;
                border-radius: 10px !important;
                padding: 12px 16px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: space-between !important;
                min-height: 56px !important;
                box-sizing: border-box !important;
                flex-wrap: wrap !important;
            }

            /* Hide default TIB square uploading container & progress bar */
            .tee-field--photo .tee-photo .tee-photo-uploading,
            .tee-field--photo .tee-photo .tee-progress,
            .tee-field--photo .tee-photo .tee-product-loading {
                display: none !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-photo-head {
                display: flex !important;
                align-items: center !important;
                flex: 1 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-photo-head::before {
                content: "${t.placeholder_text}" !important;
                font-size: 14px !important;
                color: #767069 !important;
                font-weight: 400 !important;
                display: block !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-photo-label {
                display: none !important;
            }

            /* Button with Camera Icon & Orange Circular Spinner */
            .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-btn--upload,
            .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-photo-action .tee-btn,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-btn--upload {
                background: #312b36 !important;
                color: transparent !important;
                border: none !important;
                border-radius: 8px !important;
                padding: 8px 16px !important;
                font-size: 0 !important;
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 8px !important;
                min-width: 80px !important;
                min-height: 36px !important;
                cursor: not-allowed !important;
                pointer-events: none !important;
                box-shadow: none !important;
                position: relative !important;
            }

            .tee-field--photo .tee-photo .tib-camera-icon {
                display: inline-flex !important;
                font-size: 14px !important;

                svg {
                    margin-top: 3px;
                }
            }

            .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-btn--upload::after,
            .tee-field--photo .tee-photo:has(.tee-photo-uploading) .tee-photo-action .tee-btn::after {
                content: "" !important;
                width: 14px !important;
                height: 14px !important;
                border: 2px solid rgba(255, 255, 255, 0.25) !important;
                border-top-color: #F16522 !important;
                border-right-color: #F16522 !important;
                border-radius: 50% !important;
                animation: tib-btn-spin 0.75s linear infinite !important;
                display: inline-block !important;
            }

            @keyframes tib-btn-spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }

            /* --- 4. UPLOAD BOX (UPLOADED STATE) --- */
            .tee-field--photo .tee-photo:has(.tee-photo-image):not(:has(.tee-photo-uploading)),
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-image):not(:has(.tee-photo-uploading)) {
                background: #F4F0E8 !important;
                border: 1.5px dashed #D6D0C5 !important;
                border-radius: 10px !important;
                padding: 10px 16px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: space-between !important;
                min-height: 56px !important;
                box-sizing: border-box !important;
                flex-wrap: wrap;
                gap: 5px;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-head,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-head {
                display: flex !important;
                flex-wrap: wrap;
                align-items: center !important;
                gap: 12px !important;
                flex: 0 0 52px !important;
                min-width: 0 !important;
                flex-wrap: wrap;
                width: 100%;
                flex: 1 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-image {
                width: 42px !important;
                height: 42px !important;
                object-fit: contain !important;
                border-radius: 6px !important;
                flex-shrink: 0 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-label,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-label {
                display: flex !important;
                align-items: center !important;
                font-size: 13.5px !important;
                color: #312B36 !important;
                font-weight: 500 !important;
                white-space: nowrap !important;
                text-overflow: ellipsis !important;
                max-width: 220px !important;
                margin-bottom: 0 !important;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-uploaded,
            .teeinblue-theme-modern .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-uploaded {
                display: flex !important;
                align-items: center !important;
                gap: 8px !important;
            }

            .tee-photo-preview-history {
                flex: 0 0 auto
            }
            .tee-photo-preview-history__image {
                height: 42px !important;
            }

            /* Edit Button */
            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-btn--edit,
            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-action .tee-btn {
                background: #312b36 !important;
                color: #FAF8F5 !important;
                border: none !important;
                border-radius: 8px !important;
                padding: 8px 10px !important;
                font-size: 13.5px !important;
                font-weight: 600 !important;
                cursor: pointer !important;
                gap: 8px;
                transition: background-color 0.2s ease !important;
            }

            .tee-field--photo .tee-photo .tee-photo-action {
                flex: 1 !important;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;
            }

            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-btn--edit:hover,
            .tee-field--photo .tee-photo:has(.tee-photo-image) .tee-photo-action .tee-btn:hover {
                background: #1B1720 !important;
            }

            /* --- 4. MAGIC STUDIO AI LOADING POPUP --- */
            .tib-ai-modal-backdrop {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100dvh;
                background: rgba(0, 0, 0, 0.65);
                backdrop-filter: blur(3px);
                -webkit-backdrop-filter: blur(3px);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 999999999;
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.3s ease;
                touch-action: none;
            }

            .tib-ai-modal-backdrop.tib-active {
                opacity: 1 !important;
                pointer-events: auto !important;
            }

            .tib-ai-modal-content {
                background: #FCECEC;
                border-radius: 16px;
                box-shadow: 0 10px 40px rgba(0, 0, 0, 0.18);
                width: 440px;
                max-width: 92vw;
                padding: 28px 20px 20px 20px;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                position: relative;
                box-sizing: border-box;
                transform: scale(0.95);
                transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
            }

            .tib-ai-modal-backdrop.tib-active .tib-ai-modal-content {
                transform: scale(1);
            }

            .tib-ai-modal-content.tib-closing {
                transform: scale(0.95);
                opacity: 0;
                transition: transform 0.25s ease, opacity 0.25s ease;
            }

            /* AI Loader Icon and Glow (hidden) */
            .tib-ai-glow-wrap {
                display: none !important;
            }

            /* Magic Studio Subtitle (hidden) */
            .tib-ai-sub-title {
                display: none !important;
            }

            /* Main Title (Lora Serif) */
            .tib-ai-main-title {
                font-family: 'Lora', Georgia, serif;
                font-size: 26px;
                font-weight: 600;
                color: #2B2533;
                margin: 0 0 16px 0;
                text-align: center;
                line-height: 1.25;
                letter-spacing: -0.2px;
            }

            /* Uploaded Photo Preview Card in AI Modal */
            .tib-ai-preview-card {
                background: #FFFFFF;
                border-radius: 14px;
                box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.20);
                padding: 12px;
                margin: 0 auto 20px auto;
                width: 100%;
                max-width: 85%;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 140px;
                max-height: 280px;
                overflow: hidden;
            }

            .tib-ai-preview-img {
                max-width: 100%;
                max-height: 250px;
                width: auto;
                height: auto;
                object-fit: contain;
                border-radius: 8px;
                display: block;
            }

            /* Status Row: Processing status on left, percentage on right */
            .tib-ai-status-row {
                display: flex;
                align-items: baseline;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 10px;
            }

            .tib-ai-status-label {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                font-size: 15px;
                font-weight: 700;
                color: #2B2533;
                line-height: 1.2;
            }

            .tib-ai-percent-large {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                font-size: 30px;
                font-weight: 500;
                color: #D80000;
                margin: 0;
                line-height: 1;
            }

            /* Progress Bar Container */
            .tib-ai-progress-track {
                width: 100%;
                height: 2px;
                background: #E8D6D6;
                border-radius: 2px;
                position: relative;
                overflow: hidden;
                margin-bottom: 4px;
            }

            /* Progress Bar Fill */
            .tib-ai-progress-bar {
                height: 100%;
                background: #D80000;
                border-radius: 2px;
                width: 0%;
                position: relative;
                transition: width 0.2s linear;
            }

            .tib-ai-progress-dot {
                display: block;
                position: absolute;
                right: -4px;
                top: 50%;
                transform: translateY(-50%);
                width: 8px;
                height: 8px;
                background: #F16522;
                border-radius: 50%;
                box-shadow: none;
            }

            /* Bottom Subtext */
            .tib-ai-subtext {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                font-size: 13px;
                font-weight: 400;
                color: #767069;
                margin: 0 0 20px 0;
                text-align: left;
            }

            /* Divider & Footer Text */
            .tib-ai-divider {
                display: block !important;
                width: 100%;
                height: 1px;
                background: #E8D6D6;
                margin: 0 0 14px 0;
            }

            .tib-ai-footer-text {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                font-size: 12.5px;
                font-weight: 400;
                color: #767069;
                margin: 0;
                text-align: center;
            }

            /* --- 6. GUIDELINES MODAL --- */
            .tib-guideline-modal-backdrop {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100dvh;
                background: rgba(0, 0, 0, 0.65);
                backdrop-filter: blur(2px);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 999999999;
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.3s ease;
            }

            .tib-guideline-modal-backdrop.tib-active {
                opacity: 1 !important;
                pointer-events: auto !important;
            }

            .tib-guideline-modal-content {
                background: #FFFFFF;
                border-radius: 14px;
                width: 520px;
                max-width: 92vw;
                max-height: 90vh;
                overflow-y: auto;
                padding: 24px;
                position: relative;
                box-sizing: border-box;
            }

            .tib-guideline-close-btn {
                position: absolute;
                top: 14px;
                right: 14px;
                width: 32px;
                height: 32px;
                border: none;
                background: #F4F0E8;
                border-radius: 50%;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background-color 0.2s ease;
            }

            .tib-guideline-close-btn:hover {
                background: #E5DFC0;
            }

            .tib-guideline-close-btn svg {
                width: 14px;
                height: 14px;
                fill: #312B36;
            }

            .tib-guideline-image-only {
                width: 100%;
                height: auto;
                border-radius: 8px;
                display: block;
            }

            /* Scroll Lock */
            html.tib-popup-scroll-lock,
            body.tib-popup-scroll-lock {
                overflow: hidden !important;
            }

            .tee-field--photo .tee-photo.tee-multiple-photo .tee-photo-label.tee-multiple-photo-add {
                display: inline-flex !important;
            }
            .tee-field--photo .tee-photo.tee-multiple-photo .tee-photo-label.tee-multiple-photo-add .tee-photo-placeholder {
                max-width: 48px;
                max-height: 48px;
            }
            .tee-field--photo .tee-photo.tee-multiple-photo .tee-multiple-photo-item {
                max-width: 52px;
                max-height: 52px;
            }
            .tee-field--photo .tee-photo.tee-multiple-photo .tee-multiple-photo-status {
                width: 100%;
            }
            .tee-field--photo .tee-photo.tee-multiple-photo .tee-photo-action .tee-btn {
                white-space: normal;
                max-height: fit-content !important;
            }


        `;
        (document.head || document.documentElement).appendChild(style);
    }

    // Inject styles early
    injectUnifiedStyles();

    // ====================================================================
    // 3. CAMPAIGN DATA INTERCEPTOR (AI Layer Detection)
    // ====================================================================
    window.tibAiLayerData = window.tibAiLayerData || new Map();
    let isCampaignDataParsed = false;

    function parseCampaignObject(campaign) {
        if (!campaign || !Array.isArray(campaign.artworks)) return false;
        isCampaignDataParsed = true;

        const processLayers = (layers) => {
            if (!Array.isArray(layers)) return;
            layers.forEach(layer => {
                let isMagicAi = false;
                let isEditorAi = false;
                const hasRemoveBg = layer.remove_bg === true || layer.remove_bg === 1;

                if (Array.isArray(layer.effects)) {
                    isMagicAi = layer.effects.some(effect => (effect.type || "").includes("image_filter"));
                    isEditorAi = layer.effects.some(effect => /background_remover|face_cutout|gray_scale|contour_cut|photo_enhancer|watercolor|portrait_sketch/.test(effect.type || ""));
                }

                if (isMagicAi) {
                    window.tibAiLayerData.set(String(layer.id), 'ai');
                } else if (hasRemoveBg || isEditorAi) {
                    window.tibAiLayerData.set(String(layer.id), 'editor');
                }
            });
        };

        campaign.artworks.forEach(artwork => {
            if (artwork.data) {
                artwork.data.forEach(template => {
                    processLayers(template.layers);
                });
            }
        });

        return true;
    }

    function handleCampaignEvent(e) {
        const detail = e.detail;
        if (!detail) return;
        const campaign = detail.campaign || detail.campaignData || detail;
        parseCampaignObject(campaign);
    }

    // Intercept Teeinblue network fetch safely
    (function () {
        const originalFetch = window.fetch;
        window.fetch = async function (...args) {
            const url = args[0];
            const response = await originalFetch.apply(window, args);

            if (typeof url === 'string' && url.includes('.json') && (url.includes('/campaigns/') || url.includes('/platform-products/') || url.includes('api.teeinblue.com'))) {
                try {
                    const clone = response.clone();
                    clone.json().then(data => {
                        if (data && Array.isArray(data.artworks)) {
                            parseCampaignObject(data);
                        }
                    }).catch(() => { });
                } catch (e) { }
            }

            return response;
        };
    })();

    document.addEventListener("teeinblue-event-campaign-loaded", handleCampaignEvent);
    document.addEventListener("teeinblue-event-component-injected", handleCampaignEvent);

    // Fallback: fetch campaign data if after 3.5s not yet parsed
    const isProductPage = window.location.pathname.includes('/products/');
    if (isProductPage) {
        setTimeout(async () => {
            if (isCampaignDataParsed) return;
            try {
                const shop = window.Shopify?.shop || window.location.hostname;
                const campaignConfig = window.teeinblueCampaign || window.TeeInBlueCampaign;
                if (!campaignConfig) return;

                const productId = campaignConfig.productId;
                if (!productId) return;

                const isPlatform = campaignConfig.isPlatformProduct === true;
                const version = campaignConfig.version || 1;
                const endpoint = isPlatform ? 'platform-products' : 'campaigns';

                const response = await fetch(`https://api.teeinblue.com/api/merchant/${endpoint}/${productId}.json?shop=${shop}&v=${version}`);
                if (!response.ok) return;

                const data = await response.json();
                parseCampaignObject(data);
            } catch (e) {
                tibLog("Teeinblue AI Campaign parser error:", e);
            }
        }, 3500);
    }

    // ====================================================================
    // 4. CUSTOM UPLOAD & AI POPUP LOGIC
    // ====================================================================
    function iniCustomUpload() {
        if (window._tiUploadInitialized) return;
        window._tiUploadInitialized = true;

        const guideline_image = window.TIB_GUIDELINE_IMAGE_URL || "";

        // Magic Studio Modal HTML
        const aiPopupHtml = `
            <div class="tib-ai-modal-backdrop" style="opacity: 0">
              <div class="tib-ai-modal-content">
                <div class="tib-ai-glow-wrap">
                  <img src="https://cdn.medzt.com/custom-app/2.04.73/icon-loading-ai.png" class="tib-ai-icon-img" alt="Magic Studio">
                </div>
                <p class="tib-ai-sub-title">${t.sub_title}</p>
                <h3 class="tib-ai-main-title">${t.main_title}</h3>
                
                <div class="tib-ai-preview-card" style="display: none;">
                  <img src="" class="tib-ai-preview-img" alt="Preview Photo">
                </div>
                
                <div class="tib-ai-status-row">
                  <span class="tib-ai-status-label">${t.status_text}</span>
                  <span class="tib-ai-percent-large">0%</span>
                </div>
                
                <div class="tib-ai-progress-track">
                  <div class="tib-ai-progress-bar" style="width: 0%;">
                    <div class="tib-ai-progress-dot"></div>
                  </div>
                </div>
                
                <p class="tib-ai-subtext">${t.subtext}</p>
                <div class="tib-ai-divider"></div>
                <p class="tib-ai-footer-text">${t.footer_text}</p>
              </div>
            </div>
        `;

        // Guideline Modal HTML
        const guidelineDefaultHtml = `
            <div class="tib-guideline-content-wrapper">
              <h2 style="font-size: 18px; font-weight: 600; margin-bottom: 16px; color: #312b36;">${t.guide_modal_title}</h2>
              <div style="font-size: 14px; line-height: 1.6; color: #555;">
                <p>1. Upload or replace your photo with high resolution.</p>
                <p>2. Adjust your image using the controls below the preview.</p>
                <p>3. Wait 5-10 seconds for Magic Studio AI / Background Removal to process.</p>
              </div>
            </div>
        `;

        const guidelinePopupHtml = `
            <div class="tib-guideline-modal-backdrop" style="opacity: 0">
              <div class="tib-guideline-modal-content">
                <button type="button" class="tib-guideline-close-btn" aria-label="Close">
                  <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                </button>
                <div class="tib-guideline-body">
                  ${guideline_image ? `<img src="${guideline_image}" class="tib-guideline-image-only" alt="Upload Guidelines">` : (window.TIB_GUIDELINE_HTML || guidelineDefaultHtml)}
                </div>
              </div>
            </div>
        `;

        let container = document.getElementById('tib-popups-container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'tib-popups-container';
            container.innerHTML = aiPopupHtml + guidelinePopupHtml;
            document.body.appendChild(container);
        }

        const aiBackdrop = container.querySelector('.tib-ai-modal-backdrop');
        const aiModalContent = aiBackdrop.querySelector('.tib-ai-modal-content');
        const percentText = aiBackdrop.querySelector('.tib-ai-percent-large');
        const progressBar = aiBackdrop.querySelector('.tib-ai-progress-bar');
        const previewCard = aiBackdrop.querySelector('.tib-ai-preview-card');
        const previewImg = aiBackdrop.querySelector('.tib-ai-preview-img');

        function setPopupPreviewImage(url) {
            if (!previewImg || !previewCard) return;
            if (url) {
                previewImg.src = url;
                previewCard.style.display = 'flex';
            } else {
                previewImg.src = '';
                previewCard.style.display = 'none';
            }
        }

        const guidelineBackdrop = container.querySelector('.tib-guideline-modal-backdrop');
        const guidelineModalContent = guidelineBackdrop.querySelector('.tib-guideline-modal-content');
        const popupLockClass = 'tib-popup-scroll-lock';

        function syncPopupScrollLock() {
            const shouldLock = aiBackdrop.classList.contains('tib-active') || guidelineBackdrop.classList.contains('tib-active');
            document.documentElement.classList.toggle(popupLockClass, shouldLock);
            document.body.classList.toggle(popupLockClass, shouldLock);
        }

        function updateProgress(percent) {
            let val = percent;
            if (typeof val === 'string') {
                val = val.replace('%', '').trim();
            }
            percentText.textContent = `${val}%`;
            progressBar.style.width = `${val}%`;
        }

        let hideAiTimeout = null;
        function showAiPopup() {
            if (hideAiTimeout) {
                clearTimeout(hideAiTimeout);
                hideAiTimeout = null;
            }
            if (!aiBackdrop.classList.contains('tib-active')) {
                aiBackdrop.classList.add('tib-active');
                aiModalContent.classList.remove('tib-closing');
            }
            syncPopupScrollLock();
        }

        function hideAiPopup() {
            if (aiBackdrop.classList.contains('tib-active')) {
                if (hideAiTimeout) return;
                hideAiTimeout = setTimeout(() => {
                    aiModalContent.classList.add('tib-closing');
                    setTimeout(() => {
                        aiBackdrop.classList.remove('tib-active');
                        hideAiTimeout = null;
                        syncPopupScrollLock();

                        progressBar.style.transition = 'none';
                        updateProgress(0);
                        void progressBar.offsetWidth;
                        progressBar.style.transition = '';
                    }, 250);
                }, 400);
            } else {
                syncPopupScrollLock();
            }
        }

        function showGuidelinePopup() {
            if (!guidelineBackdrop.classList.contains('tib-active')) {
                guidelineBackdrop.classList.add('tib-active');
                guidelineModalContent.classList.remove('tib-closing');
            }
            syncPopupScrollLock();
        }

        function hideGuidelinePopup() {
            if (guidelineBackdrop.classList.contains('tib-active')) {
                guidelineModalContent.classList.add('tib-closing');
                setTimeout(() => {
                    guidelineBackdrop.classList.remove('tib-active');
                    syncPopupScrollLock();
                }, 250);
            } else {
                syncPopupScrollLock();
            }
        }

        guidelineBackdrop.querySelectorAll('.tib-guideline-close-btn').forEach(btn => {
            btn.addEventListener('click', hideGuidelinePopup);
        });

        guidelineBackdrop.addEventListener('click', (e) => {
            if (e.target === guidelineBackdrop) {
                hideGuidelinePopup();
            }
        });

        // Fake Progress Engine
        let fakeProgressInterval = null;
        let currentFakePercent = 0;
        let targetMax = 95;

        function startFakeProgress() {
            if (fakeProgressInterval) return;
            currentFakePercent = 0;
            targetMax = 95;

            progressBar.style.transition = 'none';
            updateProgress(0);
            void progressBar.offsetWidth;
            progressBar.style.transition = '';

            fakeProgressInterval = setInterval(() => {
                if (currentFakePercent < targetMax) {
                    let increment = (currentFakePercent < 70) ? 1.5 : (currentFakePercent < 85 ? 0.8 : 0.3);
                    currentFakePercent = Math.min(targetMax, currentFakePercent + increment);
                    updateProgress(Math.floor(currentFakePercent));
                }
            }, 180);
        }

        function stopFakeProgress() {
            if (fakeProgressInterval) {
                clearInterval(fakeProgressInterval);
                fakeProgressInterval = null;
            }
        }

        function getAiFieldMode(el) {
            const photoWrapper = el.closest(".tee-photo") || el.closest(".tee-field--photo");
            if (!photoWrapper) return false;

            const fieldEl = el.closest(".tee-field") || photoWrapper;
            const fileInput = photoWrapper.querySelector("input[type='file']");
            const heading = fieldEl.querySelector(".tee-field__heading, .tee-field__title, .tee-field-title");
            const headingText = heading ? heading.textContent.toLowerCase() : "";

            let matchedMode = null;

            if (window.tibAiLayerData && window.tibAiLayerData.size > 0) {
                const searchKeys = [
                    fileInput?.id,
                    fileInput?.name,
                    fileInput?.getAttribute('data-field-id'),
                    fileInput?.getAttribute('data-layer-id'),
                    photoWrapper.id,
                    photoWrapper.getAttribute('data-field-id'),
                    photoWrapper.getAttribute('data-layer-id'),
                    fieldEl.id,
                    fieldEl.getAttribute('data-field-id'),
                    fieldEl.getAttribute('data-layer-id')
                ].filter(Boolean).map(String);

                window.tibAiLayerData.forEach((layerMode, layerId) => {
                    const lId = String(layerId);
                    if (searchKeys.some(key => key.includes(lId) || lId.includes(key))) {
                        matchedMode = layerMode;
                    }
                });
            }

            if (matchedMode) return matchedMode;

            // Heuristics
            if (headingText.includes('ai') || headingText.includes('magic') || headingText.includes('filter') || headingText.includes('gemini') || headingText.includes('flux') || headingText.includes('gpt')) {
                return 'ai';
            }
            if (headingText.includes('remove') || headingText.includes('cutout') || headingText.includes('editor') || headingText.includes('background') || headingText.includes('bg')) {
                return 'editor';
            }

            return 'ai';
        }

        let showTimeout = null;
        let isClosedByUser = false;

        function checkTeeinblueLoading() {
            const rawLoadingEls = document.querySelectorAll(`
                .tee-photo .tee-progress--loading,
                .tee-photo .tee-photo-uploading,
                .tee-photo .tee-product-loading,
                .tee-photo .tee-progress,
                .tee-photo__progress,
                .tee-field--photo .tee-progress--loading,
                .tee-field--photo .tee-photo-uploading,
                .tee-field--photo .tee-product-loading,
                .tee-field--photo .tee-progress,
                .tee-photo:has(.tee-progress),
                .tee-photo:has(.tee-photo-uploading)
            `);
            const loadingEls = Array.from(rawLoadingEls).filter(el => getAiFieldMode(el) !== false);
            const isRealLoading = loadingEls.length > 0;

            if (isRealLoading) {
                if (!previewImg.getAttribute('src')) {
                    const activeImg = document.querySelector('.tee-photo .tee-photo-image, .tee-photo-uploaded img');
                    if (activeImg && activeImg.src) {
                        setPopupPreviewImage(activeImg.src);
                    }
                }
                if (!isClosedByUser) {
                    if (!aiBackdrop.classList.contains('tib-active') && !showTimeout) {
                        showTimeout = setTimeout(() => {
                            showAiPopup();
                            showTimeout = null;
                        }, 50);
                    }
                }
                startFakeProgress();
            } else {
                if (fakeProgressInterval) {
                    stopFakeProgress();
                    updateProgress(100);
                }
                if (showTimeout) {
                    clearTimeout(showTimeout);
                    showTimeout = null;
                }
                hideAiPopup();
            }
        }

        // 5. INJECT UI ELEMENTS (View Photo Guide & Instructions & Camera icon)
        const INFO_ICON_SVG = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path d="M10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5ZM10 8.7915C9.53998 8.79166 9.16681 9.16482 9.16667 9.62484V12.9582C9.16677 13.4182 9.53996 13.7913 10 13.7915C10.46 13.7913 10.8332 13.4182 10.8333 12.9582V9.62484C10.8332 9.16482 10.46 8.79167 10 8.7915ZM9.95687 6.2085C9.49749 6.20955 9.1253 6.58245 9.12516 7.04183V7.12484C9.12526 7.58489 9.49846 7.95801 9.9585 7.95817H10.0415C10.5015 7.95801 10.8747 7.58489 10.8748 7.12484V7.04102C10.8747 6.81994 10.7864 6.60801 10.6299 6.45182C10.4733 6.2956 10.261 6.20733 10.0399 6.20768L9.95687 6.2085Z" fill="#312B36"/>
            </svg>
        `;

        const CAMERA_PLUS_SVG = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M6.57812 0C6.92322 0 7.20299 0.279934 7.20312 0.625C7.20312 0.970178 6.9233 1.25 6.57812 1.25H2.29199C1.7167 1.25 1.25 1.7167 1.25 2.29199V9.78906C1.28438 9.74722 1.3213 9.70721 1.36035 9.66895L3.39551 7.6748C3.96997 7.11201 4.88392 7.09608 5.47754 7.63867L10.1475 11.9072H10.8652C11.4402 11.907 11.907 11.4402 11.9072 10.8652V6.57812C11.9074 6.23309 12.1872 5.95312 12.5322 5.95312C12.877 5.95348 13.1571 6.23331 13.1572 6.57812V10.8652C13.157 12.1306 12.1306 13.157 10.8652 13.1572H2.29199C1.02646 13.1572 0.000192396 12.1307 0 10.8652V2.29199C1.07378e-07 1.02634 1.02634 0 2.29199 0H6.57812ZM10.1484 0C10.448 0.000132462 10.6904 0.243339 10.6904 0.542969V1.74512C10.6904 2.4683 10.691 2.46875 11.4141 2.46875H12.6143C12.9138 2.46875 13.157 2.7112 13.1572 3.01074C13.1572 3.31045 12.914 3.55371 12.6143 3.55371H11.4141C10.6909 3.55371 10.6904 3.5539 10.6904 4.27734V5.47949C10.6903 5.77903 10.448 6.02135 10.1484 6.02148C9.84879 6.02148 9.60558 5.77911 9.60547 5.47949V4.27734C9.60547 3.55378 9.6054 3.55371 8.88184 3.55371H7.68164C7.38193 3.55371 7.13867 3.31045 7.13867 3.01074C7.13887 2.7112 7.38205 2.46875 7.68164 2.46875H8.88184C9.60532 2.46875 9.60547 2.46843 9.60547 1.74512V0.542969C9.60547 0.243257 9.84873 0 10.1484 0Z" fill="#FAF8F5"/>
            </svg>
        `;

        function injecFieldElements() {
            const photoFields = document.querySelectorAll('.tee-field--photo');
            photoFields.forEach(field => {
                // 1. Inject "View Photo Guide" link in header (if enabled)
                if (window.TIB_ENABLE_PHOTO_GUIDE) {
                    const header = field.querySelector('.tee-field__header') || field.querySelector('.tee-field__heading');
                    if (header && !header.querySelector('.tib-view-photo-guide')) {
                        const guideBtn = document.createElement('div');
                        guideBtn.className = 'tib-view-photo-guide';
                        guideBtn.innerHTML = `${INFO_ICON_SVG}<span>${t.guide_btn_text}</span>`;
                        guideBtn.addEventListener('click', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            showGuidelinePopup();
                        });
                        header.appendChild(guideBtn);
                    }
                }

                // 2. Inject Camera icon in Select Photo button
                const uploadBtn = field.querySelector('.tee-btn--upload');
                if (uploadBtn && !uploadBtn.querySelector('.tib-camera-icon')) {
                    const iconSpan = document.createElement('span');
                    iconSpan.className = 'tib-camera-icon';
                    iconSpan.innerHTML = CAMERA_PLUS_SVG;
                    uploadBtn.prepend(iconSpan);
                }
            });
        }

        // Debounced DOM Scanner using requestAnimationFrame
        let rafId = null;
        const debouncedScan = () => {
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                rafId = null;
                checkTeeinblueLoading();
                injecFieldElements();
            });
        };

        const observer = new MutationObserver(debouncedScan);
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
        });

        // 0ms UX response on file input selection
        document.addEventListener('change', (e) => {
            if (e.target && e.target.type === 'file') {
                const file = e.target.files && e.target.files[0];
                if (file) {
                    try {
                        const blobUrl = URL.createObjectURL(file);
                        setPopupPreviewImage(blobUrl);
                    } catch (err) {
                        tibLog('Could not create object URL', err);
                    }
                }
                checkTeeinblueLoading();
                debouncedScan();
            }
        }, true);

        // Capture history thumbnail selection
        document.addEventListener('click', (e) => {
            const historyItem = e.target.closest('.tee-photo-preview-history__item, .tee-photo-preview, .tee-photo-item');
            if (historyItem) {
                const img = historyItem.querySelector('img');
                if (img && img.src) {
                    setPopupPreviewImage(img.src);
                }
            }
        }, true);

        debouncedScan();
    }

    // Initialize
    if (document.readyState === "complete" || document.readyState === "interactive") {
        iniCustomUpload();
    } else {
        document.addEventListener("DOMContentLoaded", iniCustomUpload);
    }
    document.addEventListener("teeinblue-event-component-injected", iniCustomUpload);
})();
